module.exports = __webpack_public_path__ + "media/images/front/pc/article/thum01-c6807e1c4731ad9ec5bec54af79669af.png";